<template>
  <div class="flex flex-col items-start">
    <InputLabel v-if="props.label" :for="id" :optional="!props.required">
      {{ props.label }}
    </InputLabel>
    <div class="input flex">
      <span class="flex items-center justify-center pr-2 text-black/50"
        >+61</span
      >
      <BaseInput
        :id="id"
        v-model="value"
        class="flex-grow placeholder:text-black/50 focus:outline-none"
        :disabled="props.disabled"
        :mask="mask"
        :required="props.required"
        type="tel"
      />
    </div>
    <InputError :error="errorMessage" />
  </div>
</template>

<script setup lang="ts">
import type { InputProps } from './types'
import type { BaseInputProps } from '@/components/base/input/types'

interface InputPhoneProps extends BaseInputProps, InputProps {}

const props = defineProps<InputPhoneProps>()
const { id, value, errorMessage } = useInput<string>(props.name)

const mask = (value: string) => {
  let pattern: string

  const digits = value
    .replace(/\D/g, '')
    .split('')
    .map((d) => parseInt(d, 10))

  switch (digits[0]) {
    case 0:
      pattern = digits[1] === 4 ? '#### ### ###' : '(##) #### ####'
      break
    case 4:
      pattern = '### ### ###'
      break
    default:
      pattern = '# #### ####'
      break
  }

  return pattern
}
</script>
